import { render, staticRenderFns } from "./WeekNavigator.vue?vue&type=template&id=25228d7a"
import script from "./WeekNavigator.vue?vue&type=script&lang=ts"
export * from "./WeekNavigator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports